import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
function Breadcrumb() {
    return (
        <div className="breadcrumbStyle">
            <div className="container">
                <Link to="/">Trang chủ</Link>
                <span className="breadcrumbSeparator">
                    <FontAwesomeIcon icon="angle-right" />
                </span>
                <span>
                    <Link to="/about-us/tab=tin-tuc">Giới thiệu về chúng tôi</Link>
                </span>
                <span className="breadcrumbSeparator">
                    <FontAwesomeIcon icon="angle-right" />
                </span>
                <span className="active">
                    Tin tức
                </span>
            </div>
        </div>
    );
}
export default Breadcrumb;
